import * as moment from 'moment'
import * as React from 'react'
import { _route } from 'routes/config'
import SnackbarService from '../../services/snackbars'
import { withLettersOnly } from '../../services/validate'
import Content from './content'
import { IAddChildProps, IAddChildState } from './interfaces'

export class AddChild extends React.PureComponent<
  IAddChildProps,
  IAddChildState
> {
  constructor(props: IAddChildProps) {
    super(props)

    const {
      history: {
        location: {}
      }
    } = this.props

    this.state = {
      loading: false,
      patientId: props.currentPatient ? props.currentPatient.patientId : ''
    }
  }

  keyPressed = (e: KeyboardEvent) => {
    switch (e.keyCode) {
      case 13:
        this.enterPressed(e)
        break
      default:
        break
    }
  }

  enterPressed = e => {
    e.preventDefault()
    this.onSubmit()
  }

  componentDidMount() {
    document.addEventListener('keydown', this.keyPressed)
    window.scrollTo(0, 0)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.keyPressed)
  }

  goToQuestioners = () => {
    const { patientId } = this.state
    const { history, PatientsLib } = this.props
    PatientsLib.setCurrentPatient(patientId, () =>
      history.push(_route.questionnaires(patientId))
    )
  }

  goToGames = () => {
    const { patientId } = this.state
    const { history, PatientsLib } = this.props
    PatientsLib.setCurrentPatient(patientId, () =>
      history.push(_route.games(patientId))
    )
  }

  sendChildIdToMixPanel = () => {
    console.log('attempt to sendChildIdToMixPanel')
    // const { mixpanel, patients, authData } = this.props
    // const { patientId } = this.state
    // const patient = patients.find(p => p.patientId === patientId)
    // mixpanel.identify(authData.uid)
    // mixpanel.people.set({
    //   [`$child_${patients.indexOf(patient) + 1}_id`]: patientId
    // })
  }

  onSubmit = () => {
    const { valid, dateOfBirth, first_name } = this.props
    const { loading } = this.state

    if (!valid) {
      SnackbarService.showSnackbar('Fill the fields correctly please', 'error')
      return
    } else if (loading) {
      this.setState({ loading: true })
    }

    if (!withLettersOnly(first_name)) {
      SnackbarService.showSnackbar(
        'Only letters are allowed in a first name field',
        'error'
      )
      return
    }

    const maxDate = moment().subtract(0, 'years')
    const minDate = moment().subtract(100, 'years')
    const birth = moment(dateOfBirth)

    if (birth.diff(maxDate) > 0 || birth.diff(minDate) < 0) {
      SnackbarService.showSnackbar(
        "GiantLeap can't be used by children older than 100 or younger than 0",
        'error'
      )
      return
    }

    this.setState({ loading: true })
    this.savePatient()
  }

  savePatient = () => {
    const {
      childDetails,
      authData,
      user,
      mixpanel,
      history,
      PatientsLib
    } = this.props

    const parentData = {
      email: user.email,
      name: user.full_name,
      phone_number: '',
      id_parent: authData.uid
    }

    const patientData = {
      birth_date: moment(childDetails.dateOfBirth).unix(),
      patient_avatar: '',
      first_name: childDetails.first_name,
      gender: childDetails.gender,
      is_new: true
    }

    // if (!online) {
    //   SnackbarService.showSnackbar('Internet connection problem', 'error', true)
    // }

    PatientsLib.savePatient(
      patientData,
      parentData,
      null,
      (children, patientId) => {
        const minDate = moment().subtract(4, 'years')
        const birth = moment(childDetails?.dateOfBirth)

        if (birth.diff(minDate) > 0) {
          history.push(_route.abilities(patientId), {
            isChildWarnModal: true
          })
        } else {
          history.push(_route.abilities(patientId), {
            isCongratulationsModalOpen: true
          })
        }

        this.setState({
          loading: false,
          patientId
        })
        SnackbarService.close()

        mixpanel.identify(authData.uid)
        mixpanel.track('Create child', {
          date: moment().unix(),
          'child age': moment().diff(birth, 'years'),
          'child birthdate': birth.unix()
        })

        // if (!plus_user) {
        //   // set current patient
        //   this.props.PatientsLib.setCurrentPatient(patientId)
        //   history.replace(_route.payment, { page: 'addChild' })
        // }
      },
      message => {
        SnackbarService.showSnackbar(message, 'error')
        this.setState({ loading: false })
      }
    )
  }

  goBackAction = (close: boolean = false) => {
    const { history } = this.props
    // const { page } = this.state

    if (close) {
      history.push(_route.child.list)
      return
    }

    // if (page === 'avatar') {
    //   this.setState({ page: AddChildPageEnum.form })
    // } else {
    //   history.goBack()
    // }
  }

  onChangeRadio = (name: string, value: string) => {
    this.props.change(name, value)
  }

  render() {
    const { valid, childDetails, dateOfBirth } = this.props
    const { loading } = this.state

    return (
      <Content
        isValidForm={valid}
        onSubmit={this.onSubmit}
        goBackAction={this.goBackAction}
        loading={loading}
        childDetails={childDetails}
        onChangeRadio={this.onChangeRadio}
        history={this.props.history}
        goToQuestioners={this.goToQuestioners}
        goToGames={this.goToGames}
        dateOfBirth={dateOfBirth}
        sendChildIdToMixPanel={this.sendChildIdToMixPanel}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/AddChild/addChild.tsx